export enum CUSTOMER_AUTHORITY {
  ADMIN_CUSTOMER = 1,
  CUSTOMER = 2,
}

export const COMPANY_ROLE_NAME = {
  [CUSTOMER_AUTHORITY.ADMIN_CUSTOMER]: "得意先の管理者",
  [CUSTOMER_AUTHORITY.CUSTOMER]: "得意先",
};

export interface ICustomerUser {
  claim_code?: string;
  customer_code: string;
  account_authority?: CUSTOMER_AUTHORITY;
  account_supervisor_name?: string;
  login_id?: string;
  login_password?: string;
  mail_address?: string;
  is_changed_password?: boolean;
  tax_numbering_kbn?: number;
}

export class CustomerUserDTO implements ICustomerUser {
  claim_code?: string;
  customer_code: string;
  account_authority?: CUSTOMER_AUTHORITY;
  account_supervisor_name?: string;
  login_id?: string;
  login_password?: string;
  mail_address?: string;
  is_changed_password?: boolean;
  m_cart_customer: any;
  tax_numbering_kbn?: number;
}

export default class CustomerUser extends CustomerUserDTO {
  original = {};
  constructor(dto?: CustomerUserDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }
  public new() {
    Object.assign(this, {
      claim_code: "",
      customer_code: "",
      account_authority: 1,
      account_supervisor_name: "",
      mail_address: "",
      is_changed_password: false,
    });
  }
}
